import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, formatApiError } from "../lib/api";

export default function JoinRedirect() {
    const { code } = useParams();
    const { status } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (status === "loading") return;
        if (status !== "authed") {
            sessionStorage.setItem("onsetflow_pending_invite", code || "");
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await api.post("/projects/join", {
                    invite_code: (code || "").toUpperCase(),
                });
                navigate(`/projects/${data.id}`, { replace: true });
            } catch (e) {
                sessionStorage.setItem(
                    "onsetflow_join_error",
                    formatApiError(e)
                );
                navigate("/projects/join", { replace: true });
            }
        })();
    }, [code, status, navigate]);

    return (
        <div
            data-testid="join-redirect-page"
            className="min-h-screen flex items-center justify-center text-neutral-500 text-sm"
        >
            Joining project…
        </div>
    );
}
